import { MutationHookOptions, MutationResult } from "@apollo/client";
import { useMutation } from "../../../hooks";
import { FetchResult } from "@apollo/client/link/core";
import { removeFromMatterExclusionsCache } from "../../query";
import {
  deleteExclusions,
  deleteExclusionsVariables,
} from "../../__generated_types__/deleteExclusions";
import { graphql } from "~/gql";

export const DELETE_EXCLUSIONS_MATTER = graphql(/* GraphQL */ `
  mutation deleteExclusions($input: [Int!]!) {
    deleteExclusions(input: $input) {
      exclusionIds
    }
  }
`);

export type DeleteExclusionsMutationFunction = (
  matterId: number,
  exclusionIds: number | number[],
  options?: MutationHookOptions<deleteExclusions, deleteExclusionsVariables>
) => Promise<FetchResult<deleteExclusions>>;

export function useDeleteExclusionsMutation(
  options?: MutationHookOptions<deleteExclusions, deleteExclusionsVariables>
): [DeleteExclusionsMutationFunction, MutationResult<deleteExclusions>] {
  const [mutationFunction, mutationResult] = useMutation<
    deleteExclusions,
    deleteExclusionsVariables
  >(DELETE_EXCLUSIONS_MATTER, {
    ...(options || {}),
    errorPolicy: "all",
  });
  const deleteExclusionsMutation: DeleteExclusionsMutationFunction = (
    matterId,
    exclusionIds,
    options
  ) => {
    return mutationFunction({
      variables: {
        input: Array.isArray(exclusionIds) ? exclusionIds : [exclusionIds],
      },
      update(cache) {
        removeFromMatterExclusionsCache(cache, matterId, exclusionIds);
      },
      ...(options || {}),
    });
  };
  return [deleteExclusionsMutation, mutationResult];
}
